import type { Cents } from './types.ts';

const cad = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });

const cadWhole = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });

/** 3800 -> "$38.00"; with `{ whole: true }` round amounts print as "$38" (titles, headlines). */
export function formatCad(cents: Cents, opts: { whole?: boolean } = {}): string {
  return opts.whole && cents % 100 === 0 ? cadWhole.format(cents / 100) : cad.format(cents / 100);
}

/** "38.00" or 38 -> 3800. Rejects anything that is not a clean money amount. */
export function toCents(amount: string | number): Cents {
  const n = typeof amount === 'number' ? amount : Number(amount.replace(/[^0-9.-]/g, ''));
  if (!Number.isFinite(n)) throw new Error(`not a money amount: ${amount}`);
  return Math.round(n * 100);
}

/** 3800 -> "38.00", for schema.org price fields and e-Transfer instructions. */
export function centsToDecimal(cents: Cents): string {
  return (cents / 100).toFixed(2);
}
